<button mat-raised-button *appRole="['DetalleServicios.Crear']" color="primary" (click)="openDialogCreateDetalleServicio()" class="btn-nuevo">
  <mat-icon>add</mat-icon>
  Nuevo detalle servicio
</button>
<br>
<br>
<app-listado-detalle-servicio-propiedad *appRole="['DetalleServicios.Ver']" [update]="update" [idPropiedad]="idPropiedad"></app-listado-detalle-servicio-propiedad>
